// @ts-nocheck
import { useRef, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import SolyticsEditor from '../../../SolyticsEditor/SolyticsEditor';
import { useDebouncedInput } from '../../../../hooks/useDebouncedInput';

const HIDDEN_TOOLBAR_ITEMS = [
  'youtube',
  'iframe',
  'AdvanceTableWithFields',
  'addChart',
];

const TOOLBAR_PROPS = {
  sx: {
    position: 'static',
    border: 'none',
    borderRadius: 0,
    borderBottom: '1px solid',
    borderColor: 'divider',
    zIndex: 1,
    width: '100%',
  },
};

const CanvasEditor = forwardRef(function CanvasEditor(
  { value, readOnly = false, placeholder = '', onChange = () => {} },
  ref
) {
  const editorRef = useRef(null);
  const { localValue, setValue, flush } = useDebouncedInput(
    value ?? '',
    onChange
  );

  useImperativeHandle(
    ref,
    () => ({
      flush,
    }),
    [flush]
  );

  return (
    <Box sx={{ height: 472 }}>
      <SolyticsEditor
        ref={editorRef}
        content={localValue}
        editable={!readOnly}
        hideToolbar={readOnly}
        hiddenToolbarItems={HIDDEN_TOOLBAR_ITEMS}
        placeholder={placeholder}
        gap={0}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
        useEditorOptions={{
          onUpdate: ({ editor }) => {
            setValue(editor.getHTML());
          },
          onBlur: () => {
            flush();
          },
        }}
        SolyticsEditorToolbarProps={TOOLBAR_PROPS}
      />
    </Box>
  );
});

CanvasEditor.propTypes = {
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

export default CanvasEditor;
